<template>
  <v-col>
    <v-window v-model="step">
      <v-window-item :value="1">
        <v-row>
          <v-col cols="12">
            <div class="text-h4">Do you have an PBX – Phone System Vendor?</div>
            <v-radio-group v-model="formData.has_pbx_vendor">
              <template v-slot:label>
                <div>
                  Please Let us know if you have a <strong>PBX – Phone System Vendor</strong>.
                  <MoreInfoToolTip :msg="msg" />
                </div>
              </template>
              <v-radio value="y">
                <template v-slot:label>
                  <div>Yes, I do have PBX – Phone System Vendor</div>
                </template>
              </v-radio>

              <v-radio value="n">
                <template v-slot:label>
                  <div>No, I do not have a PBX – Phone System Vendor</div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-window-item>

      <v-window-item
        :value="2"
        class="pa-6"
      >
        <v-row>
          <v-col cols="12">
            <div class="text-h4">PBX – Phone System Vendor's contact information.</div>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="formData.pbx_vendor_company_name"
              label="Vendor Company Name"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="formData.pbx_vendor_company_number"
              label="Vendor Company Number"
              v-mask="'(###) ###-####'"
            ></v-text-field>
          </v-col>
        </v-row>

        <Contact
          :d="contactData"
          :roles="['PBX – Phone System Vendor']"
          @assignContact="assignContact"
        />
      </v-window-item>
    </v-window>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import _ from 'lodash';
import MoreInfoToolTip from '@/components/menus/MoreInfoToolTip.vue';
import Contact from '@/components/formfields/Contact.vue';

export default {
  name: "PBXVendorInfo",
  data: () => ({
    step: 1,
    msg: "This applies to you if you are using a third party vendor for you IT services.",
    formData: {},
  }),
  mounted() {
    const vm = this;
    const generalData = _.cloneDeep(vm.getFormData.general);

    this.$set(this.formData, 'has_pbx_vendor', (generalData.has_pbx_vendor || "n"));
    this.$set(this.formData, 'pbx_vendor_company_name', generalData.pbx_vendor_company_name);
    this.$set(this.formData, 'pbx_vendor_company_number', generalData.pbx_vendor_company_number);
    this.$set(this.formData, 'pbx_vendor_contact_name', generalData.pbx_vendor_contact_name);
    this.$set(this.formData, 'pbx_vendor_contact_number', generalData.pbx_vendor_contact_number);
    this.$set(this.formData, 'pbx_vendor_contact_email', generalData.pbx_vendor_contact_email);

    // refs AIF-82: remove step 1 if vendor contact exists
    if (generalData.pbx_vendor_contact_number) {
      this.$set(this.formData, 'pbx_has_vendor', "y");
      this.step = 2;
    }
    if (!this.review) {
      this.hijackStepper((goRight) => {
        if (
          (vm.step === 1 && !goRight)
          || (vm.step === vm.maxStep && generalData.pbx_vendor_contact_number && !goRight)
          || (vm.step === vm.maxStep && goRight)
        ) {
          vm.unHijackStepper();
          vm.nextSubTab(goRight);
        }

        vm.step += goRight ? 1 : -1;
      });
    }
  },
  beforeDestroy() {
    this.unHijackStepper();
  },
  methods: {
    ...mapActions([
      'updateStoreFormData',
      "hijackStepper",
      "unHijackStepper",
      "nextSubTab",
    ]),
    assignContact(e) {
      this.$set(this.formData, 'pbx_vendor_contact_name', e.fullname);
      this.$set(this.formData, 'pbx_vendor_contact_number', e.phone);
      this.$set(this.formData, 'pbx_vendor_contact_email', e.email);
    },
    registerFormChange(val) {
      const keys = Object.keys(val);
      keys.forEach((key) => {
        this.updateStoreFormData({
          data: val[key],
          main: 'general',
          sub: key,
        });
      });
    },
  },
  computed: {
    ...mapGetters(['getFormData']),
    maxStep() {
      if (this.formData.has_pbx_vendor === 'n') {
        return 1;
      }
      return 2;
    },
    contactData() {
      return {
        fullname: this.formData.pbx_vendor_contact_name,
      };
    },
  },
  watch: {
    formData: {
      handler(val) {
        this.registerFormChange(val);
      },
      deep: true,
    },
  },
  components: {
    MoreInfoToolTip,
    Contact,
  },
};
</script>
